import Logo from 'Components/Logo'
import MarkdownWrapper from 'Components/MarkdownWrapper'
import { getUserLanguage } from 'Lib'
import React from 'react'
import styled from 'styled-components'

const Center = styled.div`
  display: flex;
  justify-content: center;
  `
const MaxWidth = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.xLarge};
  white-space-collapse: collapse;
`

const RefundPolicyContainer: React.FC = () => {
  const language = getUserLanguage()
  const filePath = `assets/legal/RefundPolicy.${language}.md`

  return (
    <Center>
      <MaxWidth>
        <Logo/>
        <MarkdownWrapper filePath = {filePath} />
      </MaxWidth>
    </Center>
  )
}

export default RefundPolicyContainer
